module.exports = __webpack_public_path__ + "img/gift4-01-c11-t2.738a0f00.png";